import axios from 'axios';

import { useUserStore } from '@/store/userStore';

const authApi = axios.create({
  baseURL: `${import.meta.env.VITE_AUTH_API_URL}/api/v1/auth`,
  withCredentials: true,
});

authApi.interceptors.request.use((config) => {
  const { jwtToken } = useUserStore.getState();

  if (jwtToken) {
    config.headers['Authorization'] = `Bearer ${jwtToken}`;
  }
  return config;
});

export default authApi;
